import React from 'react'
import { useDispatch, useSelector } from "react-redux";

export default function DashboardConfiguration() {

    const dispatch = useDispatch();
    const state = useSelector((state) => state.adminReducer);

  return (
    <div>dashboarCconfiguration</div>
  )
}